import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { Auth0Scheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/login",
    "home": "/",
    "callback": "/"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/",
      "domain": ".importgenius.com"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "auth0"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // auth0
  $auth.registerStrategy('auth0', new Auth0Scheme($auth, {
  "endpoints": {
    "authorization": "https://staging-login.importgenius.com/authorize",
    "userInfo": "/api/account-info",
    "token": "https://staging-login.importgenius.com/oauth/token",
    "logout": "https://staging-login.importgenius.com/v2/logout"
  },
  "token": {
    "property": "id_token",
    "type": "Bearer"
  },
  "logoutRedirectUri": "https://staging-lighthouse.importgenius.com",
  "domain": "staging-login.importgenius.com",
  "clientId": "tLd6Spwj8JUAiSbTOEpq2tMkAF5eXV4c",
  "scope": [
    "openid",
    "profile",
    "email",
    "openid",
    "profile",
    "email",
    "offline_access"
  ],
  "audience": "https://staging-login.importgenius.com/api/v2/",
  "responseType": "id_token",
  "name": "auth0"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
